export default __webpack_public_path__ + "static/media/ready-set-type.db82bf3d.png";